export const MyTheme = {
  colors: {
    primaryText: '#FFFFFF',
    secondaryText: '#009BDB',
  },
  fonts: {
    poppingsNormal: 'Poppins-Regular',
    poppingsSemiBold: 'Poppins-SemiBold',
  },
};